/**
 * Show and hide fields based on a checkbox toggle
 */
admin.registerLoad(function (prefix) {

    $(prefix + '.js-checkbox-toggle').each(function () {
        var input = $(this);
        var target = $(input.data("target"));

        input.change(function () {
            toggleState();
        });

        function toggleState() {
            target.each(function () {
                if ($(this).hasClass('form-group') || $(this).hasClass('wide-form-group'))
                {
                    if (input.prop( "checked" ))
                    {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                }
            });
        }

        toggleState();
    })
});
